var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetsDoItIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 16,
    viewBox: "0 0 37 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.666,
    width: 17.3333,
    height: 16,
    fill: "#1C1C1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.666 7.99978C19.666 7.38613 19.724 6.88867 19.7955 6.88867H30.6477C30.7192 6.88867 30.7771 7.38613 30.7771 7.99978C30.7771 8.61343 30.7192 9.11089 30.6477 9.11089H19.7955C19.724 9.11089 19.666 8.61343 19.666 7.99978Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3487 2.11241C26.6471 1.81409 27.1307 1.81409 27.429 2.11241L32.7763 7.45963C33.0746 7.75795 33.0746 8.24162 32.7763 8.53993L27.429 13.8872C27.1307 14.1855 26.6471 14.1855 26.3487 13.8872C26.0504 13.5888 26.0504 13.1052 26.3487 12.8069L31.1558 7.99978L26.3487 3.19271C26.0504 2.89439 26.0504 2.41073 26.3487 2.11241Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.99984C0 7.26346 0.10434 6.6665 0.233051 6.6665H19.7669C19.8957 6.6665 20 7.26346 20 7.99984C20 8.73622 19.8957 9.33317 19.7669 9.33317H0.233051C0.10434 9.33317 0 8.73622 0 7.99984Z",
    fill: "#1C1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetsDoItIcon);
export default __webpack_public_path__ + "static/media/lets-do-it-icon.fa3f796f35530a968fe312d2e6cc41ea.svg";
export { ForwardRef as ReactComponent };